import React from 'react';
import UploadCatalogoFornecedor from '../UploadCatalogoFornecedor/UploadCatalogoFornecedor';

type Props = { closeAction: Function; closeActionSimple: Function };

const UploadGoomer: React.FC<Props> = (props) => <UploadCatalogoFornecedor {...props}
  source={"GOOMER"} title={"Importar catálogo Goomer"}
  instructions={"Copie a URL do cardápio digital da sua loja no Goomer."}
  placeholder={"https://sua-loja.goomer.app/menu"} />;

export default UploadGoomer;
